import moduleModelDerivative from './model-derivative';

export default {
  namespaced: true,
  modules: {
    modelDerivative: moduleModelDerivative,
  },
};
